import React, { useId } from "react";
import "scss/manage-users.scss";
import { useStateContext } from "state";
import UserAccountRecord from "./widgets/userAccountRecord.widget";

const UserAccountsPage: React.FC = () => {
    const userAccountRecordId = useId();
    const state = useStateContext();
    return (
        <div className="manageUsers_wrapper">
            <div className="manageUser_table_wrapper">
                <h2>Accounts</h2>
                <table className="manageUsers_table">
                    <thead>
                        <th>Name</th>
                    </thead>
                    <tbody>
                        {state.user?.roles.map((role) => (
                            <UserAccountRecord key={`${userAccountRecordId}-${role.accountId}`} role={role} />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default UserAccountsPage;
